"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NoImagesBox = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

require("./style/default.scss");

var _imageLibraryHelper = _interopRequireDefault(require("../helpers/image-library-helper"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _classnames = _interopRequireDefault(require("classnames"));

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

require("./style/my-images.scss");

var _config = require("../config");

var _imageProxyHelper = _interopRequireDefault(require("../helpers/image-proxy-helper"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _infiniteGrid = _interopRequireDefault(require("../controls/infinite-grid"));

var _CropRotate = _interopRequireDefault(require("@material-ui/icons/CropRotate"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _controlQuery = require("@eig-builder/control-query");

var _hooks = require("../hooks");

var _authUploadHelper = _interopRequireDefault(require("../helpers/auth-upload-helper"));

var _recoil = require("recoil");

var _store = require("../store");

var _myImagesDeleteModal = _interopRequireDefault(require("./my-images-delete-modal"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _storeServiceUrlHelper = _interopRequireDefault(require("../helpers/store-service-url-helper"));

require("../lang");

var _templateObject, _templateObject2, _templateObject3;

var NoImagesBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 20px;\n  text-align: center;\n  width: 100%;\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n  justify-content: center;\n"])));

exports.NoImagesBox = NoImagesBox;
var StyledIconButton = (0, _styledComponents["default"])(_compositionsButtonWithIcon["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 35px !important;\n  padding: 0 10px !important;\n  margin-left: 5px !important;\n  ", "\n"])), function (props) {
  return props.onlyIcon && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    span {\n      div {\n        div {\n          margin-right: 0 !important;\n        }\n      }\n    }\n  "])));
});
var initialAmount = 25;

var convertTagsToQueryParams = function convertTagsToQueryParams() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if ((0, _typeof2["default"])(tags) === 'object') {
    return Object.keys(tags).map(function (key) {
      return "".concat(key, "=").concat(tags[key]);
    }).join('&');
  }
};

var mapImages = function mapImages(image) {
  var imageSizes = {
    width: image.width,
    height: image.height
  };

  if ('height' in imageSizes && 'width' in imageSizes) {
    var thumbnailWidth = Number((imageSizes.width / 7).toFixed(0)) || 200;
    var thumbnailHeight = Number((imageSizes.height / 7).toFixed(0)) || 200;
    var imageProxyHelper = new _imageProxyHelper["default"](image.image_uri, 'cloudflare');
    imageProxyHelper.resizeToWidth(_config.MAX_THUMBNAIL_WIDTH);
    var imageProxyOriginal = image.image_uri;
    var thumnailImage = imageProxyHelper.result();
    return {
      thumbnail: thumnailImage,
      thumbnailWidth: thumbnailWidth,
      thumbnailHeight: thumbnailHeight,
      original: imageProxyOriginal,
      originalWidth: image.width || 500,
      // default size for images like svg that dont return a size on reading
      originalHeight: image.height || 500,
      tags: [],
      caption: '',
      color: image.color || '#eee',
      source: 'uploads',
      image_id: image.image_id
    };
  }
};

var MyImages = function MyImages(_ref) {
  var onUseImages = _ref.onUseImages,
      tags = _ref.tags,
      toggleLoading = _ref.toggleLoading,
      setActionTop = _ref.setActionTop,
      onDelete = _ref.onDelete,
      navigate = _ref.navigate,
      onSelectionChanged = _ref.onSelectionChanged,
      addToFavorite = _ref.addToFavorite;

  var _useActiveView = (0, _hooks.useActiveView)('my-images'),
      currentView = _useActiveView.currentView,
      active = _useActiveView.active;

  var fetchMyImages = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(key) {
      var page,
          tokenFromAuthCheck,
          optParams,
          uploadEndpoint,
          url,
          imageTokenHeader,
          response,
          data,
          dataToJson,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
              _context.next = 3;
              return _authUploadHelper["default"].checkAuth();

            case 3:
              tokenFromAuthCheck = _context.sent;
              optParams = convertTagsToQueryParams(tags);
              uploadEndpoint = _storeServiceUrlHelper["default"].getUrl('upload');
              url = optParams.length > 0 ? "".concat(uploadEndpoint, "/?page=").concat(page, "&pageSize=").concat(initialAmount, "&").concat(optParams) : "".concat(uploadEndpoint, "/?page=").concat(page, "&pageSize=").concat(initialAmount, "&showUntaggedImagesOnly=false");
              imageTokenHeader = new window.Headers({
                Authorization: "Bearer ".concat(tokenFromAuthCheck)
              });
              _context.next = 10;
              return (0, _fetch["default"])(url, {
                method: 'GET',
                headers: imageTokenHeader,
                simpleCall: true
              });

            case 10:
              response = _context.sent;
              _context.next = 13;
              return response;

            case 13:
              data = _context.sent;
              _context.next = 16;
              return data.json();

            case 16:
              dataToJson = _context.sent;
              return _context.abrupt("return", {
                data: dataToJson,
                page: page
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchMyImages(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var queryCache = (0, _controlQuery.useQueryCache)();
  var queryData = queryCache.getQueryData('myImages');

  var _useInfiniteQuery = (0, _controlQuery.useInfiniteQuery)('myImages', fetchMyImages, {
    refetchOnWindowFocus: false,
    initialData: function initialData() {
      return queryData;
    },
    getFetchMore: function getFetchMore(lastGroup, allGroups) {
      if (lastGroup && lastGroup.data && lastGroup.data.length < initialAmount) {
        return null;
      }

      return ((lastGroup === null || lastGroup === void 0 ? void 0 : lastGroup.page) || 0) + 1;
    }
  }),
      images = _useInfiniteQuery.data,
      status = _useInfiniteQuery.status,
      isFetching = _useInfiniteQuery.isFetching,
      fetchMore = _useInfiniteQuery.fetchMore,
      refetch = _useInfiniteQuery.refetch,
      canFetchMore = _useInfiniteQuery.canFetchMore;

  var _useMutation = (0, _controlQuery.useMutation)(function (removedIds) {
    return _imageLibraryHelper["default"].deleteMyImages(removedIds);
  }, {
    onMutate: function onMutate(removedIds) {
      queryCache.cancelQueries('myImages');
      var previousValue = queryCache.getQueryData('myImages');
      queryCache.setQueryData('myImages', function (old) {
        var newImages = (0, _toConsumableArray2["default"])(old);
        newImages.forEach(function (imagesData) {
          return imagesData.data.filter(function (image) {
            return removedIds.indexOf(image.image_id).length === -1;
          });
        });
        return newImages;
      });
      return previousValue;
    },
    onError: function onError(error, variables, previousValue) {
      if (error) {
        queryCache.setQueryData('myImages', previousValue);
      }
    },
    onSettled: function onSettled() {
      queryCache.invalidateQueries('myImages');
    }
  }),
      _useMutation2 = (0, _slicedToArray2["default"])(_useMutation, 2),
      removeImages = _useMutation2[0],
      isLoadingMutation = _useMutation2[1].isLoading;

  var _useRecoilState = (0, _recoil.useRecoilState)(_store.loadingState),
      _useRecoilState2 = (0, _slicedToArray2["default"])(_useRecoilState, 1),
      loading = _useRecoilState2[0].loading;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      deleteMode = _React$useState2[0],
      setDeleteMode = _React$useState2[1];

  var _React$useState3 = _react["default"].useState([]),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      selectedImages = _React$useState4[0],
      setSelectedImages = _React$useState4[1];

  _react["default"].useEffect(function () {
    toggleLoading(isLoadingMutation);
  }, [isLoadingMutation]);

  var resetDeleteState = _react["default"].useCallback(function () {
    toggleLoading(false);
    setDeleteMode(false);
    setSelectedImages([]);
  }, []);

  var deleteImages = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var selectedIds, deletedImages;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              toggleLoading(true);
              selectedIds = images.map(function (images) {
                return images.data;
              }).flat().filter(function (image, index) {
                return selectedImages.indexOf(index) > -1;
              }).map(function (image) {
                return image.image_id;
              });
              removeImages(selectedIds);
              deletedImages = images.filter(function (image) {
                return selectedIds.indexOf(image.image_id) !== -1;
              }); // You can pass an onDelete function when opening the image-selector. It will call the function with the deletedImages as values

              if (onDelete) {
                onDelete(deletedImages);
              }

              resetDeleteState();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function deleteImages() {
      return _ref3.apply(this, arguments);
    };
  }();

  var enableDeleteMode = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (deleteMode && selectedImages.length > 0) {
                deleteImages();
              } else {
                setDeleteMode(!deleteMode);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function enableDeleteMode() {
      return _ref4.apply(this, arguments);
    };
  }();

  var setActions = function setActions(value) {
    if (images && images.length > 0) {
      var classes = (0, _classnames["default"])('delete-my-images', {
        selected: value === true || deleteMode === true
      });

      var showDeleteButton = function showDeleteButton() {
        if (selectedImages.length > 0) {
          return /*#__PURE__*/_react["default"].createElement(_myImagesDeleteModal["default"], {
            confirmClick: deleteImages,
            cancelClick: function cancelClick() {
              setSelectedImages([]);
              setDeleteMode(false);
            },
            amountSelected: selectedImages.length,
            key: "delete-my-images-modal",
            loading: loading
          });
        }

        if (deleteMode) {
          return /*#__PURE__*/_react["default"].createElement(_compositionsButtonWithIcon["default"], {
            tag: "delete-image-from-my-images",
            labelPosition: "after",
            fullWidth: true,
            variant: deleteMode ? 'contained' : 'outlined',
            color: "warning",
            icon: /*#__PURE__*/_react["default"].createElement("i", {
              className: "material-icons"
            }, "delete"),
            dataElementLabel: "image-selector--nav--delete-images",
            dataElementLocation: _taggingHelper.DataElementLocations.NAV,
            dataElementId: "image-selector--nav--delete-images",
            key: "delete-my-images",
            onClick: enableDeleteMode
          }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
            message: "imagepicker.delete"
          }));
        }
      };

      var actions = [/*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        key: "delete-my-images"
      }, showDeleteButton())];
      setActionTop(actions);
    }
  };

  _react["default"].useEffect(function () {
    if (!deleteMode) {
      setActions();
    }
  }, [deleteMode]);

  _react["default"].useEffect(function () {
    if (active) {
      if (Array.isArray(images)) {
        queryCache.removeQueries('myImages', {
          exact: true
        });
        refetch();
      }

      setActions();
    }

    if (currentView !== 'my-images') {
      setDeleteMode(false);
      setSelectedImages([]);
    }
  }, [currentView, active]); // if we deleted some images/or turned off delete mode, reset the action buttons in the header to clear the delete buttons again


  _react["default"].useEffect(function () {
    if (active) {
      setActions();
    }
  }, [selectedImages.length]);

  var selectImageForDeleting = function selectImageForDeleting(imageIndex) {
    var index = selectedImages.findIndex(function (imageId) {
      return imageId === imageIndex;
    });
    var newImages = index === -1 ? [].concat((0, _toConsumableArray2["default"])(selectedImages), [imageIndex]) : selectedImages.filter(function (image) {
      return image !== imageIndex;
    });
    setSelectedImages(newImages);
    setDeleteMode(true);
  };

  var onImageSelect = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(index) {
      var imageToSelect;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              imageToSelect = images.filter(function (imageData) {
                return imageData === null || imageData === void 0 ? void 0 : imageData.data;
              }).map(function (data) {
                return data.data;
              }).flat().map(mapImages)[index];
              onSelectionChanged(imageToSelect, 'my-images', true);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onImageSelect(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  var selectForEdit = function selectForEdit(index) {
    var imageToSelect = images.filter(function (imageData) {
      return imageData === null || imageData === void 0 ? void 0 : imageData.data;
    }).map(function (data) {
      return data.data;
    }).flat().map(mapImages)[index];
    onSelectionChanged(imageToSelect, 'my-images');
  };

  var selectFunc = function selectFunc(index, imageId) {
    setActions();
    return deleteMode ? selectImageForDeleting(index) : onImageSelect(index);
  };

  if (!active) return null;

  var getImageOptions = function getImageOptions() {
    var returnOptions = [{
      icon: /*#__PURE__*/_react["default"].createElement(_CropRotate["default"], {
        fontSize: "small"
      }),
      onClick: selectForEdit,
      tooltip: 'Edit',
      showLabel: true
    }];
    returnOptions.push({
      icon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
        fontSize: "small"
      }),
      onClick: selectImageForDeleting,
      tooltip: 'Delete'
    });
    return returnOptions;
  };

  var dataToDisplay = (images || []).filter(function (imageData) {
    return imageData === null || imageData === void 0 ? void 0 : imageData.data;
  }).map(function (data) {
    return data.data;
  }).flat().map(mapImages).map(function (photo, index) {
    return {
      onClick: function onClick() {
        return selectFunc(index, photo.image_id);
      },
      src: photo.thumbnail,
      width: photo.originalWidth,
      height: photo.originalHeight,
      backgroundColor: '#eee',
      key: "".concat(index),
      selected: selectedImages.findIndex(function (image) {
        return image === index;
      }) > -1,
      actions: {
        topRight: getImageOptions().map(function (option, optionIndex) {
          var onClickWithIndex = function onClickWithIndex(e) {
            e.stopPropagation();
            option.onClick(index);
          };

          return /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
            key: "icon-".concat(option.tooltip),
            size: "medium",
            color: "secondary",
            onClick: onClickWithIndex,
            icon: option.icon,
            labelPosition: "after",
            tag: "image-hover-actions-btn",
            onlyIcon: !option.showLabel,
            dataElementLabel: "image-selector--image-grid--".concat(option.tooltip),
            dataElementLocation: _taggingHelper.DataElementLocations.BODY,
            dataElementId: "image-selector--image-grid--".concat(option.tooltip)
          }, option.showLabel && option.tooltip);
        })
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view default"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view-content full"
  }, Array.isArray(dataToDisplay) && dataToDisplay.length === 0 && !isFetching && status === 'success' && /*#__PURE__*/_react["default"].createElement(NoImagesBox, null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.noImagesYet"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "images"
  }, Array.isArray(images) && /*#__PURE__*/_react["default"].createElement(_infiniteGrid["default"], {
    data: dataToDisplay,
    loading: isFetching,
    loadMore: fetchMore,
    more: canFetchMore
  })))));
};

MyImages.propTypes = {
  onUseImages: _propTypes["default"].func,
  tags: _propTypes["default"].object,
  toggleLoading: _propTypes["default"].func.isRequired,
  setActionTop: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func,
  navigate: _propTypes["default"].func,
  onSelectionChanged: _propTypes["default"].func,
  addToFavorite: _propTypes["default"].func
};

var _default = (0, _withContext["default"])(MyImages);

exports["default"] = _default;